import { GetIsParticipantsNumberMatchingConf } from './types/getIsParticipantsNumberMatchingConf.types'

export const getIsParticipantsNumberMatchingConf: GetIsParticipantsNumberMatchingConf = (
  participantsNumber,
  minMaxPax
) => (
  (minMaxPax.minPax === undefined || participantsNumber >= Number(minMaxPax.minPax)) &&
  (minMaxPax.maxPax === undefined || participantsNumber <= Number(minMaxPax.maxPax))
)
